import * as React from "react"

import errorImg from "../images/error.png"
import { Link } from "react-router-dom"

const NotFoundPage = () => (
    <section className="error-area">
      <div className="d-table">
        <div className="d-table-cell">
          <div className="container">
            <div className="error-content">
              <img src={errorImg} alt="Error" />
              <h3>Error 404 : Page Not Found</h3>
              <p>
                The page you are looking for might have been removed had its
                name changed or is temporarily unavailable.
              </p>

              <div className="btn-box">
                <Link to="/" className="default-btn">
                  <i className="flaticon-history"></i>Go Back Homepage<span className="default-btn-hover"></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
)


export default NotFoundPage
